import React from 'react';

export default () => (
  <div className="loader-fullscreeen">
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="24" />
    </svg>
  </div>
);
